import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import { LanguageProvider } from "./context/LanguageContext";
import Layout from "./components/Layout/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Deposits from "./pages/Deposits";
import Loans from "./pages/Loans";
import Calculator from "./pages/Calculator";
import Contact from "./pages/Contact";
import MemberInquiry from "./pages/MemberInquiry";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/deposits" element={<Deposits />} />
                            <Route path="/loans" element={<Loans />} />
                            <Route path="/calculator" element={<Calculator />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/membership" element={<MemberInquiry />} />
                            <Route path="*" element={<Home />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
